import { useState } from "react";
import { Link } from "react-router-dom";
import img1 from "../../images/commentcamarche/rectangle-20.png";
import img2 from "../../images/commentcamarche/rectangle-18.png";

// Define image mappings for each event type
const eventImageMap = {
  Loft: {
    img1: img1,
    img2: img2,
  },
  "Salle de réception": {
    img1: img2,
    img2: img1,
  },
  "Salle de réunion": {
    img1: img1,
    img2: img2,
  },
  Studio: {
    img1: img2,
    img2: img1,
  },
  "Hammam/Spa": {
    img1: img2,
    img2: img1,
  },
  Théâtre: {
    img1: img1,
    img2: img2,
  },
  Véranda: {
    img1: img2,
    img2: img1,
  },
  Véranda: {
    img1: img1,
    img2: img2,
  },
  "Boutique éphémère": {
    img1: img2,
    img2: img1,
  },
  Rooftop: {
    img1: img1,
    img2: img2,
  },
  "Jardin/Piscine/Terrasse": {
    img1: img1,
    img2: img2,
  },
  Péniche: {
    img1: img2,
    img2: img1,
  },
  Villa: {
    img1: img1,
    img2: img2,
  },
};

// Define descriptions for each event type
const eventDescriptionMap = {
  Loft: "Louez un loft aménagé pour un événement qui sort de l’ordinaire. Idéal pour des réunions intimistes, séances photo originales ou ateliers créatifs. Ces espaces vous offrent un cadre chaleureux et atypique.",
  "Salle de réception":
    "Louez des salles de réception élégantes et modulables pour vos mariages, anniversaires, soirées de gala ou événements d’entreprise. Profitez d’un cadre exceptionnel qui s’adapte à toutes vos exigences en termes de capacité, de décoration et de confort.",
  "Salle de réunion":
    "Besoin d’un lieu professionnel pour vos séminaires, réunions d’équipe ou conférences ? Découvrez des espaces modernes et fonctionnels offrant des installations adaptées.",
  Studio:
    "Créez une ambiance unique avec un studio privatisé. Parfait pour des shootings photo, tournages vidéo ou événements créatifs dans un cadre professionnel et modulable",
  "Hammam/Spa":
    "Offrez-vous un moment de détente unique dans un hammam ou spa privatif. Idéal pour des séances bien-être, EVJF, anniversaires relaxants ou petits événements intimistes alliant confort et sérénité",
  Théâtre:
    "Réservez un théâtre pour une présentation, un spectacle ou un événement professionnel dans un cadre chargé d’émotion. Parfait pour captiver votre audience dans une ambiance unique et scénographiée.",
  "Jardin/Piscine/Terrasse":
    "Organisez un événement en extérieur dans un jardin arboré, une piscine privative ou une terrasse aménagée. Parfait pour des cocktails, fêtes d’été ou événements en plein air.",
  Véranda:
    "Organisez un événement lumineux et élégant dans une véranda au design raffiné. Parfait pour des réceptions, brunchs ou événements privés en toute intimité..",
  Rooftop:
    "Offrez à vos invités une vue imprenable sur la ville avec un rooftop élégant. Idéal pour des soirées, afterworks, cocktails ou shootings photo au coucher du soleil.",
  Péniche:
    "Organisez un événement original et convivial sur une péniche. Parfait pour des soirées privées, EVJF, anniversaires ou réceptions au fil de l’eau, profitez d’un cadre unique et chaleureux pour vos moments inoubliables.",
  Villa:
    "Trouvez une villa d’exception pour organiser un événement en plein air, un mariage champêtre ou une réception privée de prestige. Des lieux uniques offrant confort, charme et exclusivité.",
  "Boutique éphémère":
    "Louez une boutique éphémère pour votre lancement de produit, pop-up store ou exposition artistique. Un espace parfait pour marquer les esprits en plein cœur de Paris.",
};

const AboutUsPage = () => {
  const eventTypes = [
    "Loft",
    "Salle de réception",
    "Salle de réunion",
    "Studio",
    "Hammam/Spa",
    "Véranda",
    "Boutique éphémère",
    "Villa",
    "Jardin/Piscine/Terrasse",
    "Rooftop",
    "Péniche",
    "Théâtre",
  ];

  // State to track the selected event type
  const [selectedEvent, setSelectedEvent] = useState(eventTypes[0]);

  // Get images and description based on selected event type
  const currentImages = eventImageMap[selectedEvent] || eventImageMap["Loft"];
  const currentDescription = eventDescriptionMap[selectedEvent] || eventDescriptionMap["Loft"];

  return (
    <>
      <div className="p-6 mt-36 rbt-about-area about-style-1 dark:bg-neutral-800">
        <div className="max-w-6xl mx-auto font-sans">
          {/* Heading */}
          <h2 className="mb-4 text-5xl font-bold text-gray-800 dark:text-white">
            Trouvez votre espace événementiel parmi nos lieux d’exception
          </h2>

          {/* Description */}
          <p className="mb-6 text-gray-600 dark:text-gray-500">
            Vous cherchez un espace événementiel à Paris pour organiser un événement unique ? Que ce soit pour un
            mariage, une soirée d’entreprise, un séminaire, un lancement de produit ou une fête privée, trouvez
            l’endroit parfait grâce à notre plateforme. Découvrez une sélection d’espaces événementiels à louer :
            salles de réception, lofts, jardins ou lieux atypiques, adaptés à tous types de projets.
          </p>

          {/* Event Type Buttons */}
          <div className="grid grid-cols-2 gap-3 mb-6 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
            {eventTypes.map((type) => (
              <button
                key={type}
                onClick={() => setSelectedEvent(type)}
                className={`px-4 py-2 text-sm font-medium transition-colors border-2 rounded-full text-eventToBee border-eventToBee ${
                  selectedEvent === type ? "bg-eventToBee text-white" : "hover:bg-eventToBee hover:text-white"
                }`}
              >
                {type}
              </button>
            ))}
          </div>

          {/* Image Section */}
          <div className="grid grid-rows-1 gap-4 md:grid-cols-3">
            <div className="rounded-full">
              <img
                src={currentImages.img2}
                alt={`${selectedEvent} Image 1`}
                className="object-contain w-full h-full"
              />
            </div>
            <div className="flex flex-col justify-between items-center rounded-2xl p-6 min-h-[300px] w-full sm:w-4/5 mx-auto [background:linear-gradient(180deg,rgba(247,157,203,1)_0%,rgba(70,99,172,1)_100%)]">
              <p className="w-full text-base text-white text-start sm:text-lg">{currentDescription}</p>

              <div className="flex justify-center w-full mt-auto group">
                <Link to={"/espace-evenementiel"}>
                  <div className="flex items-center justify-center px-6 transition-colors duration-300 ease-in-out bg-white rounded-full cursor-pointer h-14 w-fit group-hover:bg-eventToBee">
                    <span className="text-2xl font-semibold text-center transition-colors duration-300 ease-in-out text-eventToBee group-hover:text-white">
                      Réserver
                    </span>
                  </div>
                </Link>
              </div>
            </div>

            <div className="rounded-full">
              <img
                src={currentImages.img1}
                alt={`${selectedEvent} Image 2`}
                className="object-fill w-full h-full"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutUsPage;
